import script from "./UartIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./UartIndex.vue?vue&type=script&setup=true&lang=js"

import "./UartIndex.vue?vue&type=style&index=0&id=e466be20&lang=css"

const __exports__ = script;

export default __exports__